
import {
  IonTabBar,
  IonIcon,
  IonLabel,
  IonTabButton,
  IonMenuButton,
  IonBadge,
  IonModal,
  IonButton,
} from '@modus/ionic-vue'
import cart from '@/composables/cart'
import { defineComponent, ref } from 'vue'
import Menu from '@/components/Menu.vue'
import CartComponent from '@/components/CartComponent.vue'
import { menuController } from '@ionic/core'
import { close } from 'ionicons/icons'
import { addIcons } from 'ionicons'

addIcons({ close })

export default defineComponent({
  name: 'NavBar',
  components: {
    IonTabBar,
    IonIcon,
    IonLabel,
    IonTabButton,
    IonMenuButton,
    Menu,
    IonBadge,
    IonModal,
    IonButton,
    CartComponent,
  },
  setup() {
    const isOpen = ref(false)
    function openMenuComponent() {
      menuController.open('main-menu')
    }
    function openModalComponent() {
      isOpen.value = true
    }

    function willDismiss() {
      isOpen.value = false
    }
    return {
      openMenuComponent,
      cart,
      isOpen,
      openModalComponent,
      willDismiss,
    }
  },
})
